import { Box } from "@mui/material";
import React from "react";
import NewCoursing from "./Components/NewCoursing";
import NewCoursingTable from "./Components/NewCoursingTable";
import { useStyles } from "../../theme/styles";

const Category: React.FC = () => {
  const classes = useStyles();

  return (
    <Box sx={{ p: 2 }} className={classes.indexBox}>
      <NewCoursing />
      <Box sx={{ height: "75px" }} />
      <NewCoursingTable />
    </Box>
  );
};

export default Category;
